<div class="registration-page">
	<!--Register Layout-->
	<div [ngClass]="notFirstStep()" class="stepbar">
		<div class="stepbar-progress" [ngStyle]="{'width': width}"></div>
	</div>
	<p-steps [model]="items" [(activeIndex)]="activeIndex" (activeIndexChange)="setStepBarWidth()"></p-steps>
</div>
<router-outlet></router-outlet>
